import type { ReactNode } from 'react'
import './NavBar.css'

export function NavBar({
  title,
  leading,
  trailing,
  subtitle,
  onTitleClick,
}: {
  title: string
  subtitle?: ReactNode
  leading?: ReactNode
  trailing?: ReactNode
  onTitleClick?: () => void
}) {
  const titleContent = (
    <>
      <div className="navbar__title-text">
        {title}
        {onTitleClick && <span className="navbar__title-caret" />}
      </div>
      {subtitle && <div className="navbar__subtitle">{subtitle}</div>}
    </>
  )

  return (
    <header className="navbar">
      <div className="navbar__slot navbar__slot--leading">{leading}</div>
      <div className="navbar__title">
        {onTitleClick ? (
          <button className="navbar__title-btn" onClick={onTitleClick}>
            {titleContent}
          </button>
        ) : (
          titleContent
        )}
      </div>
      <div className="navbar__slot navbar__slot--trailing">{trailing}</div>
    </header>
  )
}

export function NavBarButton({
  icon,
  label,
  onClick,
  tint,
  badge,
}: {
  icon: ReactNode
  label: string
  onClick: () => void
  tint?: string
  badge?: number
}) {
  const showBadge = typeof badge === 'number' && badge > 0
  const badgeText = showBadge ? (badge! > 9 ? '9+' : String(badge)) : ''
  return (
    <button
      type="button"
      className="navbar__button"
      aria-label={showBadge ? `${label} (${badge})` : label}
      onClick={onClick}
      style={tint ? { color: tint } : undefined}
    >
      {icon}
      {showBadge && <span className="navbar__button-badge">{badgeText}</span>}
    </button>
  )
}
